import React, { useState, useEffect } from 'react'

import { Bandeau } from './Bandeau'
import { ButtonComponent } from '../Global/Buttons'

import "./campagne.scss"
import "./campagne-mob.scss"

import datas from './data'

/**
 * 
 */
export const Campagne = (props) => {
    const [isQuestion, setIsQuestion] = useState(false);
    useEffect(() => {
        props.page(2)
    })
    return (
        <>
            <div className="top-button-container">
                {!isQuestion && (<ButtonComponent url="/question" label="Continuer" action={() => setIsQuestion({ isQuestion: true })} className="p-button-rounded p-button-raised ui-button large-icon-button" />)}
            </div>
            <div className="d-flex title-block large-font">
                {
                    datas.contenus.map((content, index) => (<Bandeau key={index} content={content} />))
                }
                <div style={{ marginTop: "55px", marginBottom: "55px" }}>
                    <ButtonComponent url="/question" action={() => setIsQuestion({ isQuestion: true })} className="bottom-button d-flex p-button-rounded p-button-large p-button-raised ui-button" />
                </div>
            </div>
        </>
    )
}
